import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Encrypt } from "../../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

//const feedback = "Ты сделал это!";

class EncryptView extends Component {
  constructor() {
    super();
    this.state = {
      dataEncrypt: {
        data: "",
        alg: "belt-ctr256",
        dataPrivKey: "",
      },
      dataPubKeyFileName: "файл",
      dataPubKeyFileIsOpen: false,
      isValidFileSize: true,
      isValidPrivKeyFileSize: true,
      privkeyFileName: "файл",
      privkeyFileIsOpen: false,
      errors: {},
    };
    ///////VerifySign Func////
    this.handleInputChangeDataEncrypt = this.handleInputChangeDataEncrypt.bind(
      this
    );
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleFileForEncryptChange = this.handleFileForEncryptChange.bind(
      this
    );
    this.handlePrivKeyChange = this.handlePrivKeyChange.bind(this);
    this.handleEncryptSubmit = this.handleEncryptSubmit.bind(this);
  }

  componentDidMount() { }
  handleSelectChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({
        dataEncrypt: { ...this.state.dataEncrypt, alg: e.target.value },
      });
    } catch (error) {
      //console.log(error);
    }
  }
  handleInputChangeDataEncrypt(e) {
    //console.log(e.target.value);
    try {
      if (e.target.value.length === 0) {
        //console.log("ok");
        document.getElementById("dataForEncrypt").disabled = false;
      } else {
        document.getElementById("dataForEncrypt").disabled = true;
      }
      this.setState({
        dataPubKeyFileName: "файл",
        dataPubKeyFileIsOpen: false,
        // signFileName: "файл",
        // signFileIsOpen: false,
        // certFileName: "файл",
        // certFileIsOpen: false,

        dataEncrypt: {
          ...this.state.dataEncrypt,
          data: btoa(unescape(encodeURIComponent(e.target.value))),
        },
      });
      //console.log(e.target.value.length);

      // //console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileForEncryptChange() {
    try {
      const file = document.getElementById("dataForEncrypt").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        document.getElementById("inputDataEncrypt").disabled = true;
        this.setState({
          dataPubKeyFileName: file.name,
          dataPubKeyFileIsOpen: true,
          isValidFileSize: true,

        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataEncrypt: { ...this.state.dataEncrypt, data: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        document.getElementById("inputDataEncrypt").disabled = false;

        this.setState({
          dataPubKeyFileName: "файл",
          dataPubKeyFileIsOpen: false,
          isValidFileSize: false,

        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handlePrivKeyChange() {
    try {
      const file = document.getElementById("filePrivkey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({
          privkeyFileName: file.name, privkeyFileIsOpen: true, isValidPrivKeyFileSize: true,
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataEncrypt: { ...this.state.dataEncrypt, dataPrivKey: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          privkeyFileName: "файл", privkeyFileIsOpen: false, isValidPrivKeyFileSize: false,
        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleEncryptSubmit(e) {
    e.preventDefault();
    try {
      //console.log(`Данные: ${this.state.dataEncrypt.data}`);
      //console.log(`алгоритм: ${this.state.dataEncrypt.alg}`);
      //console.log(`ключ: ${this.state.dataEncrypt.dataPubKey}`);
      Encrypt(
        btoa(unescape(encodeURIComponent(this.state.dataEncrypt.alg))),
        this.state.dataEncrypt.data,
        this.state.dataEncrypt.dataPrivKey,

      ).then((res) => {
        //console.log(res);
        if (res.status === 200) {
          FileDownload(res.data.encrypt, "encrypt.pem");
          document.getElementById("view").style.borderColor = "green";
        } else {
          document.getElementById("view").style.borderColor = "red";
        }
      });
    } catch (error) {
      document.getElementById("view").style.borderColor = "red";

      //console.log(error);
    }
  }

  render() {
    return (
      <div className="container">
        <h6 className="major">{this.props.encryptType}</h6>
        <Form onSubmit={this.handleEncryptSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Введите текст</Form.Label>
              <Form.Control
                id="inputDataEncrypt"
                onChange={this.handleInputChangeDataEncrypt}
                as="textarea"
                aria-label="With textarea"
              />
            </Form.Group>

            <Form.Label style={{ marginLeft: "50%" }}>или</Form.Label>

            <Form.Group
              style={{ paddingBottom: "20px", borderBottom: "1px solid white" }}
            >
              <Form.Label>Выберите файл </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataForEncrypt"
                  onChange={this.handleFileForEncryptChange}
                  isValid={this.state.dataPubKeyFileIsOpen}
                  isInvalid={!this.state.isValidFileSize}

                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.dataPubKeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Алгоритм шифрования</Form.Label>
              <Form.Control
                onChange={this.handleSelectChange}
                defaultValue={this.state.dataEncrypt.alg}
                as="select"
                custom
              >
                <option>belt-ctr256</option>
                <option>belt-ecb256</option>
                <option>belt-cbc256</option>
                <option>belt-cfb256</option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Выберите файл 32байтового ключа
              </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="filePrivkey"
                  onChange={this.handlePrivKeyChange}
                  isValid={this.state.privkeyFileIsOpen}
                  isInvalid={!this.state.isValidPrivKeyFileSize}
                  required
                  style={{ color: 'white' }}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.privkeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            {/* <Form.Label style={{ float: "left" }}>
              {this.state.dataSign.statusSign}
            </Form.Label> */}
            <Button
              style={{ float: "right" }}
              variant="success"
              type="submit"
              size="sm"
            >
              Зашифровать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(EncryptView));
